export enum UniversityEnum {
  UNIVERSITY_AFFILIATE = 'university-affiliate',
}
